<!-- Only render when open -->
@if (isOpen) {
  <div
    class="modal-backdrop"
    (click)="onBackdropClick($event)"
    aria-hidden="false"
    role="button"
    tabindex="0"
  >
    <div
      #dialog
      class="modal-dialog"
      [ngStyle]="{ 'max-width': maxWidth }"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title"
      tabindex="-1"
    >
      @if (showClose) {
        <button class="close-btn" aria-label="Close" (click)="close()">
          <img [src]="closeIcon" alt="Close" class="close" loading="lazy" />
        </button>
      }

      <div class="modal-body modal-body-v2">
        <h3>Umfang der Analysen</h3>
        <p>
          Zu zahlreichen Aktien stellt die finanzen.net GmbH AI-gestützte Analysen bereit. Diese
          fassen öffentlich verfügbare Informationen, Unternehmensdaten und Marktdaten zu einer
          strukturierten Übersicht zusammen. Die Analysen können unter anderem
          Nachrichtenentwicklungen, Analysteneinschätzungen, Unternehmenskennzahlen,
          Quartalsergebnisse sowie Chancen und Risiken eines Unternehmens umfassen.
        </p>
        <h3>Wichtige Hinweise</h3>
        <p>
          Die AI-Analysen werden automatisiert unter Einsatz künstlicher Intelligenz erstellt und
          können unvollständig, fehlerhaft oder nicht aktuell sein. Die Inhalte dienen
          ausschließlich Informationszwecken und stellen keine individuelle Anlageberatung dar.
          Persönliche Anlageziele, die finanzielle Situation, die Risikobereitschaft oder
          steuerliche Verhältnisse einzelner Nutzer werden nicht berücksichtigt.
          Anlageentscheidungen sollten nicht ausschließlich auf Grundlage der AI-Analysen getroffen
          werden.
        </p>
        <p class="modal-v2-links">
          <a routerLink="/terms" queryParamsHandling="preserve">Nutzungsbedingungen</a>
        </p>
      </div>

      <div class="options">
        @for (option of options; track option) {
          <app-option
            [text]="option"
            [isActive]="selectedOptions.includes(option)"
            (optionClick)="toggleOption(option)"
          ></app-option>
        }
      </div>

      <footer>
        <app-button (buttonClick)="confirm()" [text]="actionLabel"></app-button>
      </footer>
    </div>
  </div>
}
